//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Builder.js";
let d=[[[0,"ActionType",1,0],[0,"Description",1,0],[0,"ItemType",1,1],[0,"ItemTypeString",1,0],[0,"PaxFileName",1,0],[0,"PresentationName",1,0],[0,"RelationType",1,0],[0,"TemplateType",1,0]],[],[]];
SPLM.Drawings.MarkAsTemplateBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.MarkAsTemplateBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.MarkAsTemplateBuilder.TemplateTypeEnum = Object.freeze({
    "Sheet" : "Sheet", "ReferenceExistingPart" : "ReferenceExistingPart", "Standalone" : "Standalone"});

SPLM.Drawings.MarkAsTemplateBuilder.RelationTypeEnum = Object.freeze({
    "Master" : "Master", "Specification" : "Specification", "Manifestation" : "Manifestation"});

SPLM.Drawings.MarkAsTemplateBuilder.ItemTypeEnum = Object.freeze({
    "Any" : "Any", "NXPart" : "NXPart", "NXDrawing" : "NXDrawing"});

SPLM.Drawings.MarkAsTemplateBuilder.ActionTypeEnum = Object.freeze({
    "TemplateOnly" : "TemplateOnly", "TemplateAndPax" : "TemplateAndPax"});

export default SPLM;